import script from "./VendorSelector.vue?vue&type=script&lang=js"
export * from "./VendorSelector.vue?vue&type=script&lang=js"

export default script